import { ILibraryServiceCategory } from '@/lib/fragments/libraryServiceCategory';
import { ILibraryServiceType } from '@/lib/fragments/libraryServiceType';
import { IMeetingPlacePageServiceItem } from '@/lib/fragments/meetingPlacePageServiceItem';
import { generateCorrectSlug } from '../generate-correct-slug';
import { ServiceSubCategoryCard } from '../list-page/interfaces/list-card.interface';
import { _numTag } from './custom-list-page-constants';
import {
  IServiceSubCategoryWithChildItems,
  ListCategoryCardType,
  ServiceCategoryCard,
} from './interfaces/custom-list-card.interface';

export const createCategoryCardArray = (
  categoryList: ILibraryServiceCategory[],
): ListCategoryCardType[] => {
  return categoryList?.map((category) => getCategoryCard(category));
};

export const getCategoryCard = (
  category: ILibraryServiceCategory,
): ServiceCategoryCard => {
  // The commented code is retained for future reference.
  // if (pageIsServiceSubCategory(category)) {
  return createCategoryCard(category);
  // } else {
  //   return null;
  // }
};

export const createCategoryCard = (
  category: ILibraryServiceCategory,
): ServiceCategoryCard => {
  return {
    id: category.sys.id,
    name: category.name,
    image: category?.mediaField?.jsonBynderAsset?.originalUrl,
    cardType: 'service',
    isItAllCategories: category.isItAllCategories,
    subCategories: category.subCategoriesCollection?.items,
  };
};

export const createServiceSubCategoryCardArray = (
  subCategoryList: ILibraryServiceType[],
  childItems: IMeetingPlacePageServiceItem[],
  urlSubdirectory: string | null,
  prefix: string,
) => {
  return subCategoryList?.map((subCategory) => {
    // Show the subcategories in the list page search results if any of their child items contain the search term.
    const itemsWithSameSubCategories = childItems?.filter(
      (item) => item.serviceType?.sys?.id === subCategory?.sys?.id,
    );
    const subCategoryWithItems = {
      ...subCategory,
      childItems: itemsWithSameSubCategories,
    };
    return createServiceSubCategoryCard(
      subCategoryWithItems,
      urlSubdirectory,
      prefix,
    );
  });
};

export const createServiceSubCategoryCard = (
  page: IServiceSubCategoryWithChildItems,
  urlSubdirectory: string | null,
  prefix: string,
): ServiceSubCategoryCard => {
  const name = page.name || '';
  const firstCharIsNum = !isNaN(parseInt(name.slice(0, 1)));
  const category = page?.serviceCategory
    ? [
        {
          id: page?.serviceCategory?.sys?.id,
          name: page?.serviceCategory?.name,
        },
      ]
    : [];
  return {
    id: page?.sys?.id,
    name: page.name,
    firstChar: firstCharIsNum ? _numTag : name.slice(0, 1),
    firstCharIsNum,
    imageWrapper: page?.coverImageWrapper,
    categories: category,
    slug: generateCorrectSlug(
      {
        customizedSlug: page?.customizedSlug,
        name,
        node_locale: page?.sys?.locale,
        slug: page.slug,
      },
      prefix,
      urlSubdirectory,
    ),
    children: page.childItems,
    cardType: 'service_sub_category',
    node_locale: page?.sys?.locale,
    priority: page.priority,
  };
};
